<div class="receiving-institution">
    <div class="receiving-institution-heading">
        <h5>New Institution</h5>
    </div>
    <div class="receiving-institution-body">
        <form
            name="score-preferences-form"
            [formGroup]="userForm"
        >
            <div
                class="form-group form-inline"
                *ngIf="scoreRecipientReg.other !== true"
            >
                <label class="control-label col-md-3">
                    Country:
                </label>
                <div class="col-md-4">
                    <select
                        class="form-control"
                        formControlName="country"
                        name="country"
                        (change)="getActiveRecipientInstitutions(f.country.value, testTypeId, regId)"
                        [ngClass]="{ 'is-invalid': f.academicLevel.dirty && f.country.errors?.required }"
                    >
                        <option
                            *ngFor="let country of countries"
                            [value]="country.id"
                        >{{country.name}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group form-inline"
                 *ngIf="brandId === BrandEnum.CAEL">
                <label class="control-label col-md-3">
                    Student Number:
                </label>
                <div class="col-md-4">
                    <input
                        type="text"
                        class="form-control"
                        formControlName="studentNumber"
                        name="studentNumber"
                        placeholder="Optional"
                    />
                </div>
            </div>
            <div class="form-group form-inline"
                 *ngIf="brandId === BrandEnum.CAEL">
                <label class="control-label col-md-3">
                    Level Applying For: <span
                        class="required fa fa-asterisk"
                        *ngIf="scoreRecipientReg.other !== true"
                    ></span>
                </label>
                <div class="col-md-4">
                    <select
                        class="form-control"
                        formControlName="academicLevel"
                        name="academicLevel"
                        [ngClass]="{ 'is-invalid': f.academicLevel.dirty && f.academicLevel.errors?.required }"
                    >
                        <option
                            *ngFor="let level of academicLevels"
                            [value]=level
                        >{{level}}</option>>
                    </select>
                    <small
                        class="error"
                        *ngIf="submitted && f.academicLevel.errors?.required"
                    >Please select an academic level.</small>
                </div>
            </div>
            <div class="form-group form-inline">
                <label class="control-label col-md-3">
                    Institution: <span
                        class="required fa fa-asterisk"
                        *ngIf="scoreRecipientReg.other !== true"
                    ></span>
                </label>
                <div class="col-md-4">
                    <app-typeahead-focus
                        *ngIf="activeInstitutions"
                        [model]="scoreRecipientName"
                        [data]="listOfInstitutions"
                    ></app-typeahead-focus>
                </div>
            </div>
        </form>
        <a
            class="btn btn-primary"
            name="addInstitutionBtn"
            (click)="emitScoreRecipientReg()"
        >Add institution</a>
    </div>
</div>
